import { Subject } from "rxjs";

// interfaces
import { IArea } from "src/app/core/interfaces/location/area";
import { ICity } from "src/app/core/interfaces/location/city";
import { IRegion } from "src/app/core/interfaces/location/region";
import { ICountry } from "src/app/core/interfaces/location/country";

// enums
import { RANDOM_VALUE } from "src/app/core/enums/global/random-value";

// services
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

/**
 * types
 */
export type ISortedControls = ['region', 'city', 'area'];

export class LocationHandler {
    
    /**
     * fields
     */
    private _areas: IArea[] = null;
    private _cities: ICity[] = null;
    private _regions: IRegion[] = null;
    public isLoadingAreas: boolean = false;
    public isLoadingCities: boolean = false;
    public isLoadingRegions: boolean = false;
    public watchChange: Subject<number> = null
    private _sortedControls: ISortedControls = null

    /**
     * 
     * @param _countries 
     * @param _api 
     */
    constructor(
        private _countries: ICountry[],
        private _api: ApiResponseService
    ) {
        /**
         * handler Error
         */
        if (this._countries == null) throw `arg _countries is ${this._countries}`;
        else if (this._api == null) throw `arg _api is ${this._api}`;

        // init
        this.watchChange = new Subject();
        this.sortedControls = ['region', 'city', 'area'];

    };

    /** getters & setters */

    /**
     * controls
     */
    public get sortedControls(): ISortedControls {
        return this._sortedControls
    }
    private set sortedControls(items: ISortedControls) {
        this._sortedControls = items
    }    

    /**
     * countries
     */
    public get countries(): ICountry[] {
        return this._countries
    }

    /**
     * cities
     */
    public get regions(): IRegion[] {
        return this._regions
    }
    public set regions(items: IRegion[]) {

        try {

            /**
             * handler Error
             */
            if (items == null || Array.isArray(items) == false) throw `items is ${items}`;

            this._regions = items
        } catch (err: any) {
            console.log(new Error(err))
        }

    }     

    /**
     * cities
     */
    public get cities(): ICity[] {
        return this._cities
    }
    public set cities(items: ICity[]) {

        try {

            /**
             * handler Error
             */
            if (items == null || Array.isArray(items) == false) throw `items is ${items}`;

            this._cities = items
        } catch (err: any) {
            console.log(new Error(err))
        }

    } 
    
    /**
     * areas
     */
    public get areas(): IArea[] {
        return this._areas
    }
    private set areas(items: IArea[]) {

        try {

            /**
             * handler Error
             */
            if (items == null || Array.isArray(items) == false) throw `items is ${items}`;

            this._areas = items
        } catch (err: any) {
            console.log(new Error(err))
        }
        
    }     


    /** Methods */

    /**
     * 
     * @param id Country id
     */
    public findRegionByCountryId(id: number): void {

        try {

            /**
             * handler Error
             */
            if (id == null) throw `arg id is ${id}`;

            // Start loading
            this.isLoadingRegions = true;
            
            /**
             * reset
             */
            if (this.regions?.length > 0) this.regions = [];
            if (this.cities?.length > 0) this.cities = [];
            if (this.areas?.length > 0) this.areas = [];            

            /**
             * fire Observable to note that the values ​​have been changed;
             */
            this.watchChange.next(0)
            
            /**
             * after response api stop loading
             */
            this._api
                .getRegions(id, { 
                    params: { [RANDOM_VALUE.loader]: true }
                })
                .subscribe(
                    res => {
                        this.regions = res;
                        this.isLoadingRegions = false;
                    },
                    err => {
                        this.regions = [];
                        this.isLoadingRegions = false;
                    }
                )
            
        } catch (err: any) {
            console.log(new Error(err))
        }

    }    

    /**
     * 
     * @param id region id
     */
    public async findCitesByRegionId(id: number): Promise<void> {

        return new Promise((resolve, reject) => {

            try {
    
                /**
                 * handler Error
                 */
                if (id == null) throw `arg id is ${id}`;
    
                // Start loading
                this.isLoadingCities = true;
    
                /**
                 * reset
                 */
                if (this.cities?.length > 0) this.cities = [];
                if (this.areas?.length > 0) this.areas = [];
    
    
                /**
                 * fire Observable to note that the values ​​have been changed;
                 */
                this.watchChange.next(1)
                
                /**
                 * after response api stop loading
                 */
                this._api
                    .getCitiesByRegion(id, { 
                        params: { [RANDOM_VALUE.loader]: true }
                    })
                    .subscribe(
                        res => {

                            /**
                             * 
                             */
                            this.cities = res;

                            /**
                             * 
                             */
                            this.isLoadingCities = false;

                            /**
                             * 
                             */
                            resolve();
                        },
                        err => {
                            this.cities = [];
                            this.isLoadingCities = false;
                        }
                    )
                
            } catch (err: any) {
                reject(new Error(err))
                console.log(new Error(err))
            }
            
        })


    }

    /**
     * 
     * @param id city id
     */
    public async findAreaByCityId(id: number): Promise<void> {

        return new Promise((resolve, reject) => {

            try {
    
                /**
                 * handler Error
                 */
                if (id == null) throw `arg id is ${id}`;
    
                // Start loading
                this.isLoadingAreas = true;
    
                /**
                 * fire Observable to note that the values ​​have been changed;
                 */            
                this.watchChange.next(2)
                
                /**
                 * after response api stop loading
                 */
                this._api
                    .cityAreas(id, { 
                        params: { [RANDOM_VALUE.loader]: true }
                    })
                    .subscribe(
                        res => {

                            /**
                             * 
                             */
                            this.areas = res;
                            this.isLoadingAreas = false;

                            /**
                             * 
                             */
                            resolve();                            
                        },
                        err => {
                            this.areas = [];
                            this.isLoadingAreas = false;
                        }
                    )
                
            } catch (err: any) {
                reject(new Error(err))
                console.log(new Error(err))
            }

        })


    }


    /**
     * 
     */
    onDestroy(): void {
        this.watchChange.unsubscribe();
    }
}
